import { Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  selector: 'app-sfz-dialog',
  templateUrl: './sfz-dialog.component.html',
})
export class SfzDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SfzDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { titulo: string, mensagem: string, detalhe: string}
  ){}
}
